import { axios, BaseApiUrl } from '../axios_config';

// 获取其他出库列表
export const getStockIODataList = params =>{
    return axios.post(`${BaseApiUrl}/OtherExWarehouse/GetMobileStockIODataListAsync`, { ...params }).then(res => res.data)
}


// 获取移动端部门
export const getStockIODataDetailed = params =>{
    return axios.get(`${BaseApiUrl}/OtherExWarehouse/GetMobileStockIODataDetailedAsync`, { params }).then(res => res.data);
}

// 其他出库
export const miscellaneousIssue = params =>{
    return axios.post(`${BaseApiUrl}/OtherExWarehouse/MiscellaneousIssue`, { ...params }).then(res => res.data)
}
